import { render, staticRenderFns } from "./EmergencyNumbersModal.vue?vue&type=template&id=118b43f4&"
import script from "./EmergencyNumbersModal.vue?vue&type=script&lang=js&"
export * from "./EmergencyNumbersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports